import { Popup, Mobile, Accordion, Tabs, Carousel, Carousel_CoreInit, Form_CoreInit } from './core'
import Locator from './modules/locator'
import Rooms from './modules/rooms'
import Fancybox from '@fancyapps/fancybox'
import './plugins/newsletter-form'
import './plugins/reservation-form'
import './plugins/booking-widget'
import './plugins/group-form'
import './plugins/collaborator-form'
import './plugins/application-form'
import './plugins/contest-form'
import './plugins/featured-items'
import './plugins/mobile-image'
import './plugins/post-share'
import './plugins/table-of-contents'
import './plugins/see-more'
import './plugins/drawer'
import 'jquery.marquee'

$(function() {
  $.mlmi = {
    mobile: new Mobile(),
  }

  /* Home locations */
  $('.grid--postitem__location.grid--style--locations').each(function() {
    let self = $(this),
    items = self.find('.grid__item:not(.grid__item--all-locations)')
    while (items.length) {
      self.prepend(items.splice(Math.floor(Math.random() * items.length), 1)[0]);
    }
  })

  /* Forms */
  Form_CoreInit([
    {
      classSelector: 'builder-form',
      formOptions: {
        auto_scroll: true,
        auto_scroll_offset: $('.header').outerHeight(false) + 20,
        floating_labels: true,
        date_picker: {
          dateFormat: "dd/mm/yy",
          nextText: '',
          prevText: '',
          minDate: 0,
          maxDate: '+24M',
        },
        input_files: true,
      },
    },
  ])

  /* Carousels */
  Carousel_CoreInit([
    {
      classSelector: 'carousel--gallery',
      swiperOptions: {
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 22,
          },
          768: {
            slidesPerView: 1,
          }
        }
      },
      carouselOptions: {
        forceRebuild: true,
        groupItems: {
          slidesPerGroup: {
            mobile: false,
            desktop: 'auto',
          },
          wrapperClass: 'slides-group',
        },
        onInit: function() {
          if (!$.mlmi.mobile.isMobile) {
            $('.gallery--carrousel .slides-group').each(function() {
              if (!$(this).find('.wrapper-row').length) {
                $(this).wrapInner('<div class="row wrapper-row"></div>')
              }
            })
          }
        },
        onBeforeKill: function() {
          if ($.mlmi.mobile.isMobile) {
            $('.gallery--carrousel .grid__item').unwrap('.wrapper-row')
          }
        },
      },
    },
    {
      classSelector: 'carousel--style--hero',
      swiperOptions: {
        breakpoints: {
          0: {
            slidesPerView: 1,
            spaceBetween: 0,
            autoHeight: true,
          },
          768: {
            slidesPerView: 1,
            autoHeight: false,
          }
        }
      },
    },
    {
      classSelector: 'carousel--style--quotes',
      swiperOptions: {
        loopAdditionalSlides: 4,
      },
    },
    // {
    //   classSelector: 'carousel--style--locations',
    //   swiperOptions: {
    //     init: false,
    //   },
    // },
  ])

  /* Saintlo */
  $('.page-section:eq(0) .heading-main, .page-section:eq(0) h1').each(function() {
    if ($(this).html().substr(0, 8).toLowerCase() == 'saintlo ') {
      $(this).html($(this).html().replace($(this).html().substr(0, 8), '<span class="d-none">saintlo </span>'))
    }
  })

  $(window).on('resize load orientationchange', function() {
    header()
    $('body').css('--window-height', window.innerHeight + 'px')
    if ($('.booking-widget').length) {
      $('.booking-widget__dropdown').each(function() {
        let targetX = (window.innerWidth - $(this).outerWidth(false)) / 2,
        widgetX = $('.booking-widget').offset().left
        $(this).css('--dropdown-left', -(Math.round(widgetX - targetX)) + 'px')
      })
    }
  })

  $('.booking-widget-form .field--type-radio, .reservation-form .field--type-radio').each(function(e) {
    let name = $(this).find('.card-locator-item').data('name');
    if(name && name.includes('montreal')){
      $(this).css('order', '1');
    }
    else if(name && name.includes('ottawa')){
      $(this).css('order', '2');
    }
    else if(name){
      $(this).css('order', '3');
    }
  })

  /* Click to open menu */
  $('.header-menu__menu-btn').on('click', function(e) {
    $('body').toggleClass('--menu-open')
    e.preventDefault()
  })

  /* Primary button rollover */
  $('.btn-primary, .builder-form--contact .field__submit').each(function() {
    let wrapper = $('<div class="btn-primary__wrapper"></div>')
    if ($(this).hasClass('bg-blue')) {
      wrapper.addClass('btn-primary__wrapper--blue')
    }
    if ($(this).hasClass('bg-green')) {
      wrapper.addClass('btn-primary__wrapper--green')
    }
    if ($(this).hasClass('bg-brown')) {
      wrapper.addClass('btn-primary__wrapper--brown')
    }
    $(this).wrap(wrapper)
    $(this).on('mouseleave', function() {
      $(this).blur()
    })
  })

  /* No offers */
  if ($('.btn-primary[href="#offres-rabais"]').length && !$('#offres-rabais').length) {
    $('.btn-primary[href="#offres-rabais"]').remove()
  }
  if ($('.btn-primary[href="#offers-deals"]').length && !$('#offers-deals').length) {
    $('.btn-primary[href="#offers-deals"]').remove()
  }

  /* Click to anchor */
  $('.page-apropos a[href*="#fondation"], .page-about a[href*="#fondation"]').attr('href', '#fondation')
  $('a[href*="#postuler"]').attr('href', '#postuler')
  $('a[href*="#apply"]').attr('href', '#apply')
  $('main, .footer').find('a[href^="#"]').on('click', function() {
    let targetTop = -1
    if ($(this).attr('href') == '#top') {
      targetTop = 0
    } else if ($('a[name="' + $(this).attr('href').substring(1) + '"]').length) {
      targetTop = $('a[name="' + $(this).attr('href').substring(1) + '"]').offset().top
    } else if ($($(this).attr('href')).length) {
      targetTop = $($(this).attr('href')).offset().top - $('.header').outerHeight(false) - ($.mlmi.mobile.isMobile ? 32 : 70)
    }
    if ($('.table-of-contents').length) {
      targetTop -= $('.table-of-contents').height()
    }
    if (targetTop !== -1) {
      $('html, body').scrollTo(targetTop, 400, 5, 'easeInOutQuart')
      return false
    }
  })

  /* Popup messages */
  Popup.init()

  /* Tabs */
  Tabs.init('.tabs:not(.tabs--table-of-contents)')

  /* Accordions */
  Accordion.init()
  $('.accordion--default .accordion__header-title').each(function() {
    $(this).html($(this).html() + $(this).html() + $(this).html())
  })
  $('.accordion').each(function() {
    $(this).find('.accordion__panel .accordion__title').remove()
    if ($(this).hasClass('accordion--default')) {
      $(this).find('.accordion__header .accordion__header-title').each(function() {
        let header_title = $(this),
        header = header_title.closest('.accordion__header'),
        marquee = header_title.marquee({
          speed: 200,
          delayBeforeStart: 0,
          gap: 0,
          duplicated: true,
          startVisible: true,
          allowCss3Support: true,
        })
        marquee.marquee('pause')
        header.on('mouseenter', function() {
          marquee.marquee('resume')
        })
        header.on('mouseleave', function() {
          marquee.marquee('pause')
        })
      })
    }
  })

  /* Reservation */
  $('.reservation-form').each(function() {
    $(this).ReservationForm()
  })

  /* Widget */
  $('.booking-widget').each(function() {
    $(this).BookingWidget()
  })

  /* Newlsetter */
  $('.newsletter-form').each(function() {
    $(this).NewsletterForm()
  })

  /* Groupes */
  $('.group-form').each(function() {
    $(this).GroupForm()
  })

  $('.builder-form--groupes2').each(function() {
    $(this).GroupForm()
  })

  /* Collaborateurs */
  $('.collaborator-form').each(function() {
    $(this).CollaboratorForm()
  })

  $('.builder-form--collaborations2').each(function() {
    $(this).CollaboratorForm()
  })

  /* Emplois */
  $('.application-form').each(function() {
    $(this).ApplicationForm()
  })

  /* Concours */
  $('.contest-form').each(function() {
    $(this).ContestForm()
  })

  /* Mobile adjustment */
  $.mlmi.mobile.add(function() {
    $('.footer-newsletter__content').appendTo($('.footer__mobile-form'))
  }, function() {
    $('.footer-newsletter__content').appendTo($('.footer-newsletter'))
  })

  /* Features full list */
  $('.featured-items--full-list').each(function() {
    $(this).FeaturedItems()
  })

  /* Fancybox */
  $('[data-fancybox]').fancybox({
    loop: true,
    buttons: ['close'],
    transitionEffect: 'slide',
    i18n: {
      fr: {
        CLOSE: saintlo_l10n.CLOSE,
        NEXT: saintlo_l10n.GALLERY_NEXT,
        PREV: saintlo_l10n.GALLERY_PREV,
      },
    },
    btnTpl: {
      close:
      '<button data-fancybox-close class="fancybox-button fancybox-button--close" title="{{CLOSE}}">' +
      '<i class="icon-close"></i>' +
      "</button>",
      arrowLeft:
      '<button data-fancybox-prev class="fancybox-button fancybox-button--arrow_left" title="{{PREV}}">' +
      '<div><i class="icon-arrow-left"></i></div>' +
      "</button>",
      arrowRight:
      '<button data-fancybox-next class="fancybox-button fancybox-button--arrow_right" title="{{NEXT}}">' +
      '<div><i class="icon-arrow-right"></i></div>' +
      "</button>",
    },
    lang: saintlo_l10n.LOCALE,
    mobile: {
      clickSlide: 'close',
    },
  })

  /* Locator */
  Locator.init()

  /* Scroll events */
  if ($('body').hasClass('single-location')) {
    $(window).ScrollEvents().add(function(top) {
      if (top >= $('.page-section:nth-child(2)').offset().top) {
        $('body').addClass('--header-scrolled')
      } else {
        $('body').removeClass('--header-scrolled')
      }
    })
  }
  // if ($('body').hasClass('front-page')) {
  //   $(window).ScrollEvents().add(function(top) {
  //     if (top >= $('.carousel--style--hero').offset().top) {
  //       $('body').addClass('--header-scrolled')
  //     } else {
  //       $('body').removeClass('--header-scrolled')
  //     }
  //   })
  // }

  /* Mobile image */
  $('.mobile-image').each(function() {
    $(this).MobileImage()
  })

  /* Gallery grid */
  $('.gallery--grid__more-button').on('click', function(e) {
    $(this).closest('.gallery--grid').find('.gallery-thumbnail:first').trigger('click')
    return false
  })

  /* Post share */
  $('.post-share').each(function() {
    $(this).PostShare()
  })

  /* Table of contents */
  $('.table-of-contents').each(function() {
    $(this).TableOfContents()
  })

  /* Post share */
  $('.room-details').each(function() {
    $(this).closest('.row').addClass('--room-illustration');
  })

  /* Submenu parent */
  $('.top-menu__item--parent').each(function() {
    $(this).SubMenuParent({
      mobile: false,
    })
  })

  /* Video loop */
  $('.video-loop').each(function() {
    $(this).VideoLoop()
  })

  $('.bg-video').each(function() {
    $(this).VideoBg();
  })

  /* Tooltips */
  $('.card-hostels .featured-item__description > span').each(function() {
    let string = $(this).html()
    if (string.length > 25) {
      string = string
      .split(/[\s-]/)
      .map((v, i) => `${i && i % 5 == 0 ? "\n" : " "}${v}`)
      .join("")
      .replace('Resto bar', 'Resto-bar')
      .replace('Resto pub', 'Resto-pub')
      .trim()
    }
    $(this).html(string)
  })

  $('.single-location .grid--postitem__blog-post.grid--style--listing').each(function() {
    $(this).SeeMore(3);
  })

  $('.filter-drawer').each(function() {
    $(this).Drawer({
      toggle: '.filter-drawer__toggle',
      content: '.filter-drawer__items'
    })
  })

  // window.addEventListener('message', (event) => {
  //   if (!/^https:\/\/[a-zA-Z0-9.-]*saintlo\.ca$/.test(event.origin)) {
  //     return;
  //   }
  //   if ('data' in event && event.data && typeof event.data == 'string') {
  //     var parts = event.data.match(/\{.*\}/);
  //     if (parts) {
  //       var jsonPart = parts[0],
  //       pageInfo = JSON.parse(jsonPart),
  //       scrollTop = pageInfo.scrollTop;
  //       if (scrollTop == undefined || isNaN(scrollTop)) {
  //         scrollTop = 0;
  //       }
  //       document.body.style.setProperty('--scrolloffset', (scrollTop * 2 + 36) + 'px');
  //       document.body.style.setProperty('--galleryheight', (pageInfo.clientHeight - 124) + 'px');
  //     }
  //   }
  // });
})
